/** @file Timeline panel registration: dopesheet tabs, the transport and the `timeline` key bindings. */
import type { PanelEntry } from '../panelEntry';
import { bindings } from './bindings';
import { RememberedTimeline } from './RememberedTimeline';

/** Canvas panel docked along the bottom; stays mounted while hidden; closing it pauses playback; the open animation is remembered per project. */
export const panel: PanelEntry = { id: 'timeline', title: 'panels.timeline.title', bindings, component: RememberedTimeline, renderer: 'always' };
